import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getExcel(ctx, { queryParams, endpoint }) {
      return new Promise((resolve, reject) => {
        axios
          .get(endpoint, queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    pExcle(ctx, { data, endpoint }) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: endpoint,
          data,
          responseType: 'blob',
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchList(ctx, { queryParams, endpoint }) {
      const { lang, ...propsNoLang } = queryParams
      return new Promise((resolve, reject) => {
        axios
          .get(endpoint, { headers: { lang }, params: propsNoLang })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchItem(ctx, { queryParams, data, endpoint }) {
      if (queryParams) {
        const { lang } = queryParams
        const url = `${endpoint}/${data.id}`
        return new Promise((resolve, reject) => {
          axios
            .get(url, { headers: { lang } })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      }
      const url = `${endpoint}/${data.id}`
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, { data, endpoint, lang }) {
      return new Promise((resolve, reject) => {
        axios
          .post(endpoint, data, { headers: { lang } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, { data }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`counseling/messages/${data.id}`, data.data, {
            headers: { lang: data.lang },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    update(ctx, { data, endpoint }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`${endpoint}/${data.id}`, data.data, {
            headers: { lang: data.lang },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    transfer(ctx, { data, endpoint }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`${endpoint}`, data, {})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    delete(ctx, { data, endpoint }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${endpoint}/${data.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    groupDelete(ctx, { data, endpoint }) {
      const requestList = data.ids.map(id => axios.delete(`${endpoint}/${id}`))
      return Promise.all(requestList)
    },
    updateFileAlt(ctx, { data }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`files/${data.id}`, data.data, {
            headers: { lang: data.lang },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    groupArchive(ctx, { data, endpoint, archive }) {
      const requestList = data.ids.map(id => axios.patch(
        `${endpoint}/${id}`,
        { archive },
        {
          headers: { lang: data.lang },
        },
      ))
      return Promise.all(requestList)
    },
  },
}
